import React from 'react'

/**
 * The Taka design system's standard "eyebrow" label — uppercase mono micro-text
 * with the signature 0.2em tracking. Sits above section headings.
 *
 * Spec: playbook/design-system/components.md#eyebrow-label.
 */
export const Eyebrow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="mono text-[10px] tracking-[0.2em] text-paper-faint uppercase">{children}</span>
)
